import {ActionType, createAction, props} from '@ngrx/store';
import {AppSetting, AppSettingReq} from '../../models';

export const APP_SETTINGS = '@App/settings';
export const LOAD_APP_SETTINGS = '@App/loadSettings';

export const StoreAppSettings = createAction(
  APP_SETTINGS,
  props<{
    payload: AppSetting;
  }>()
);
export const LoadAppSettings = createAction(
  LOAD_APP_SETTINGS,
  props<{
    payload: AppSettingReq;
  }>()
);

export type AppSettingsActions =
  | ActionType<typeof StoreAppSettings>
  | ActionType<typeof LoadAppSettings>;
